/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-globals */
/* eslint-disable unicorn/no-useless-undefined */

import { Box, Button, TextField, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Add, Delete, Edit } from "@mui/icons-material";
import useViewModel from "./ViewModel";
import { EditRoleDialog } from "./Components";
import { RoleEntity } from "../../api/Role/Entity/RoleEntity";
import { useSelector } from "react-redux";
import { selectProfile } from "../../store/profile/selector";
import { FormState, UserInterfaceState } from "../../shared/Enum";
import ConfirmationDialog from "../../shared/Components/ConfirmationDialog";
import LoadingBackdrop from "../../shared/Components/LoadingBackdrop";
import { useNavigate } from "react-router-dom";
import PageContentHeader from "../../shared/Components/PageContentHeader";
import { enqueueSnackbar } from "notistack";

export function MasterRolePage() {
  const { data, method } = useViewModel();

  const [dialog, setDialog] = useState(false);
  const [createDialog, setCreateDialog] = useState(false);
  const [selectedRole, setSelectedRole] = useState<RoleEntity>({
    access: [],
    id: "",
    name: "",
  });
  const [idToDelete, setIdToDelete] = useState("");
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [filter, setFilter] = useState("");
  const profile = useSelector(selectProfile);
  const navigate = useNavigate();

  useEffect(() => {
    method.onGetRoleList(filter);
  }, [filter]);

  useEffect(() => {
    if (selectedRole.name != "") {
      setDialog(true);
    }
  }, [selectedRole]);

  useEffect(() => {
    if (FormState.isSuccess(data.formState.onUpdateRole)) {
      if (selectedRole.id == profile.roleId) {
        navigate("/");
      }
      setSelectedRole({ access: [], id: "", name: "" });
      setFilter("");
    } else if (
      FormState.isError(data.formState.onUpdateRole) ||
      FormState.isError(data.formState.onDeleteRole) ||
      FormState.isError(data.formState.onCreateRole)
    ) {
      enqueueSnackbar({
        message:
          "Oops, something went wrong. Please try again later. If the issue persists, try refreshing the page or restarting the app.",
        variant: "error",
      });
    }
  }, [data.formState]);

  const columns: GridColDef[] = [
    {
      field: "name",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Role Name</Typography>
      ),
      renderCell: (e) => <Typography className="p-3">{e.row.name}</Typography>,
      width: 800,
    },
    {
      field: "action",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Action</Typography>
      ),
      renderCell: (e) => (
        <Box className="flex gap-2">
          <Button
            variant="contained"
            className="mt-1"
            onClick={() => setSelectedRole(e.row)}
          >
            <Edit />
          </Button>
          <Button
            variant="outlined"
            className="mt-1"
            onClick={() => {
              setIdToDelete(e.row.id);
              setDeleteDialog(true);
            }}
          >
            <Delete />
          </Button>
        </Box>
      ),
      width: 200,
    },
  ];

  return (
    <Box className="flex flex-col w-full p-3 md:p-5">
      <PageContentHeader label="Role Management" />
      <ConfirmationDialog
        open={deleteDialog}
        description="Are you sure you want to delete this role?"
        onCancel={() => setDeleteDialog(false)}
        onClose={() => setDeleteDialog(false)}
        onSubmit={() => {
          method.onDeleteRole({
            binusianId: profile.binusianId,
            roleId: idToDelete,
          });
          setDeleteDialog(false);
        }}
      />
      <Box className="flex md:flex-col">
        <Box className="flex justify-end md:p-3 w-full">
          <Button
            variant="contained"
            className="flex h-min p-3"
            onClick={() => setCreateDialog(true)}
          >
            <Add />
            Add New
          </Button>
        </Box>
        <Box className="flex justify-end p-3 w-full">
          <Box className="flex justify-end w-full">
            <TextField
              label="Search"
              variant="outlined"
              className="bg-white"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </Box>
        </Box>
      </Box>
      <div className="bg-white m-3 border border-gray-400">
        <DataGrid
          rows={data.roleList}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          getRowId={(row) => row.id}
          pageSizeOptions={[5, 10]}
          autoHeight
          getRowHeight={() => "auto"}
        />
      </div>
      <EditRoleDialog
        isOpen={dialog}
        defaultValue={selectedRole}
        onClose={() => {
          setDialog(false);
          setSelectedRole({ access: [], id: "", name: "" });
        }}
        onSubmit={(e) => {
          method.onUpdateRole(e);
          setDialog(false);
        }}
      />
      <EditRoleDialog
        isOpen={createDialog}
        defaultValue={selectedRole}
        onClose={() => {
          setCreateDialog(false);
          setSelectedRole({ access: [], id: "", name: "" });
        }}
        onSubmit={(e) => {
          method.onCreateRole(e);
          setSelectedRole({ access: [], id: "", name: "" });
          setFilter("");
          setCreateDialog(false);
        }}
      />
      <LoadingBackdrop
        isOpen={
          UserInterfaceState.isLoading(data.uiState) ||
          FormState.isLoading(data.formState.onCreateRole) ||
          FormState.isLoading(data.formState.onDeleteRole) ||
          FormState.isLoading(data.formState.onUpdateRole)
        }
      />
    </Box>
  );
}
